import { useState, useEffect } from "react"
import usePrefersReducedMotion from "hooks/usePrefersReducedMotion"
import useRandomInterval from "hooks/useRandomInterval"

const DEFAULT_COLOR = "#ffc400"

const random = (min, max) => Math.floor(Math.random() * (max - min)) + min

const range = (start, end, step = 1) => {
  const output = []
  if (typeof end === "undefined") {
    // eslint-disable-next-line no-param-reassign
    end = start
    // eslint-disable-next-line no-param-reassign
    start = 0
  }
  for (let i = start; i < end; i += step) {
    output.push(i)
  }
  return output
}

const generateSparkle = (color) => {
  const sparkle = {
    id: String(random(10000, 99999)),
    createdAt: Date.now(),
    color,
    size: random(10, 20),
    style: {
      top: `${random(0, 100)}%`,
      left: `${random(0, 100)}%`,
    },
  }
  return sparkle
}

const Wrapper = ({ children }) => (
  <span className="relative inline-block">{children}</span>
)

const SparkleWrapper = ({ children, ...props }) => (
  <span className="absolute block motion-safe:animate-come-in-out" {...props}>
    {children}
  </span>
)

const SparkleSvg = ({ children, ...props }) => (
  <svg className="motion-safe:animate-spinner" {...props}>
    {children}
  </svg>
)

const Sparkle = ({ size, color, style }) => {
  const path =
    "M26.5 25.5C19.0043 33.3697 0 34 0 34C0 34 19.1013 35.3684 26.5 43.5C33.234 50.901 34 68 34 68C34 68 36.9884 50.7065 44.5 43.5C51.6431 36.647 68 34 68 34C68 34 51.6947 32.0939 44.5 25.5C36.5605 18.2235 34 0 34 0C34 0 33.6591 17.9837 26.5 25.5Z"
  return (
    <SparkleWrapper style={style}>
      <SparkleSvg width={size} height={size} viewBox="0 0 68 68" fill="none">
        <path d={path} fill={color} />
      </SparkleSvg>
    </SparkleWrapper>
  )
}

const Sparkles = ({ color = DEFAULT_COLOR, children, ...delegated }) => {
  // Start with empty sparkles so server and client render the same (avoids hydration
  // mismatch from random/Date.now()). Populate after mount.
  const [sparkles, setSparkles] = useState([])
  const prefersReducedMotion = usePrefersReducedMotion()

  useEffect(() => {
    setSparkles(range(3).map(() => generateSparkle(color)))
  }, [color])

  useRandomInterval(
    () => {
      const sparkle = generateSparkle(color)
      const now = Date.now()
      const nextSparkles = sparkles.filter((sp) => {
        const delta = now - sp.createdAt
        return delta < 750
      })
      nextSparkles.push(sparkle)
      setSparkles(nextSparkles)
    },
    prefersReducedMotion ? null : 50,
    prefersReducedMotion ? null : 450,
  )
  return (
    <Wrapper {...delegated}>
      {sparkles.map((sparkle) => (
        <Sparkle
          key={sparkle.id}
          color={sparkle.color}
          size={sparkle.size}
          style={sparkle.style}
        />
      ))}
      {children}
    </Wrapper>
  )
}

export default Sparkles
